import axios from './_defaults/api';
import { uploadImage } from './images';

export async function getActivities({params}) {
    try {
        const response = await axios.get("/activities", { params });
        return response?.data;
    } catch (error) {
        console.log(error);
        if(error.response?.status === 404) {
            return [];
        }
        throw error;
    }
}

export async function getActivity({activityId}) {
    try {
        const response = await axios.get(`/activities/${activityId}`);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function createActivity({data}) {
    try {
        const response = await axios.post(`/activities`, data);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function updateActivity({activityId, data}) {
    try {
        const response = await axios.post(`/activities/${activityId}`, data);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function removeActivity({activityId}) {
    try {
        const response = await axios.delete(`/activities/${activityId}`);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function updateActivityLogo({activityId, file}) {
    try {
        const {key} = await uploadImage({ activityId, file, params: {type: "ACTIVITY_LOGO"} });
        await updateActivity({ activityId, data: { "logo.url": key } });
        return key;
    } catch (error) {
        console.log(error);
        throw error;
    }
}


export async function createActivityOption({activityId, data}) {
    try {
        const response = await axios.post(`/activities/${activityId}/options`, data);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function removeActivityOption({activityId, params}) {
    try {
        const response = await axios.delete(`/activities/${activityId}/options`, {params});
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
